import axios, { AxiosResponse, AxiosError } from 'axios';

let isRedirecting = false;

/**
 * Setup axios interceptors for global error handling
 */
export const setupApiInterceptors = (onUnauthorized?: () => void) => {
  // Response interceptor to handle 401 errors globally
  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      // Reset redirecting flag on successful response
      isRedirecting = false;
      return response;
    },
    (error: AxiosError) => {
      // Handle 401 Unauthorized responses
      if (error.response?.status === 401 && !isRedirecting) {
        // Don't redirect on login endpoint failures
        const isLoginEndpoint = error.config?.url?.includes('/authenticate');
        
        if (!isLoginEndpoint) {
          isRedirecting = true;
          
          console.log('401 Unauthorized detected, redirecting to login...');
          
          // Clear authentication data
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          
          // Call the unauthorized callback if provided
          if (onUnauthorized) {
            onUnauthorized();
          } else {
            // Fallback: redirect to login page
            window.location.href = '/login';
          }
          
          // Reset the flag after a delay to allow for page navigation
          setTimeout(() => {
            isRedirecting = false;
          }, 1000);
        }
      }
      
      return Promise.reject(error);
    }
  );
};

/**
 * Clean up interceptors
 */
export const cleanupApiInterceptors = () => {
  axios.interceptors.response.clear();
  isRedirecting = false;
}; 